export const startVisiblePolling = (callback, intervalMs, { immediate = true } = {}) => {
  let intervalId = null
  let stopped = false

  function clearTimer() {
    if (intervalId !== null) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  function stop() {
    if (stopped) return
    stopped = true
    clearTimer()
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }

  function tick() {
    if (callback() === false) stop()
  }

  function start(runImmediately) {
    if (stopped || document.hidden || intervalId !== null) return
    if (runImmediately) tick()
    if (!stopped && !document.hidden) intervalId = setInterval(tick, intervalMs)
  }

  function handleVisibilityChange() {
    if (document.hidden) {
      clearTimer()
      return
    }
    start(true)
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)
  start(immediate)

  return stop
}
